import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Box, Tooltip } from "@mui/material";

const dateFormatter = new Intl.DateTimeFormat("es-AR", {
  timeZone: "America/Argentina/Buenos_Aires",
  hour: "2-digit",
  minute: "2-digit",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour12: false,
});

function formatLastUpdated(value) {
  if (!value) return "Sin movimientos registrados";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Sin movimientos registrados";

  const parts = dateFormatter.formatToParts(date);
  const byType = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `Última actualización: ${byType.hour}:${byType.minute} ${byType.day}/${byType.month}/${byType.year}`;
}

export default function LastUpdatedIndicator({ lastUpdatedAt }) {
  return (
    <Tooltip title={formatLastUpdated(lastUpdatedAt)} arrow placement="top">
      <Box
        aria-label="Indicador de última actualización"
        sx={{
          width: 44,
          height: 44,
          flex: "0 0 auto",
          borderRadius: "50%",
          bgcolor: "primary.500",
          color: "logoblanco",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0px 6px 18px rgba(23, 31, 76, 0.24)",
          pointerEvents: "auto",
          cursor: "default",
        }}
      >
        <AccessTimeIcon sx={{ fontSize: 22 }} />
      </Box>
    </Tooltip>
  );
}
